/** The same carrier decision at the questions round, firm result and reload. */
export function CarrierDeclined({
  carrier,
  reasons,
  next = "If an answer was wrong, change it and Continue.",
}: {
  carrier: string;
  reasons: string[];
  /** What the broker can do about it; null when no answer can change it. */
  next?: string | null;
}) {
  return (
    <div
      role="status"
      className="flex min-w-0 flex-col gap-2 break-words text-sm"
    >
      <p className="text-brk-text">{carrier} declined this application.</p>
      <h4 className="text-subheading text-brk-text">Why it was declined</h4>
      {reasons.length > 0 && (
        <ul className="list-inside list-disc text-brk-dim">
          {reasons.map((reason, i) => (
            <li key={i}>{reason}</li>
          ))}
        </ul>
      )}
      <p className="text-brk-dim">
        It gave no quote. The other markets’ quotes stand.
        {next ? ` ${next}` : ""}
      </p>
    </div>
  );
}
